import { Node } from 'reactflow';
import { DelayNodeData } from 'assets/js/pages/engage/workflows/actions/types';
import { useReactFlowStore } from 'assets/js/pages/engage/workflows/utils/store';
import { NodeWithData } from 'assets/js/pages/engage/workflows/utils/types';
import { WorkflowUtilityNodeTypeEnum } from 'constants/workflows';

const useFindDelayNode = (node?: NodeWithData): Node<DelayNodeData> | undefined => {
    const { nodes } = useReactFlowStore(({ nodes }) => ({ nodes }));
    return findDelayNodeInTree(nodes, node);
};

const findDelayNodeInTree = (
    nodes: NodeWithData[],
    node?: NodeWithData,
): Node<DelayNodeData> | undefined => {
    if (!node) return undefined;
    if (node.type === WorkflowUtilityNodeTypeEnum.DELAY) return node as Node<DelayNodeData>;

    return findDelayNodeInTree(
        nodes,
        nodes.find(n => n.id === node.data?.parentId),
    );
};

export { useFindDelayNode, findDelayNodeInTree };
